import React, { useEffect, useState } from "react";
import ProfileLogo from "../../assets/img/Profile Icon.svg";
import {
  Box,
  Avatar,
  Typography,

  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  useMediaQuery,
  useTheme,
  Badge,

  alpha,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { useNavigate } from "react-router-dom";
import { userLogout } from "../../apiCalls/apiHandler";
import { useAuth } from "../../hooks/contexts/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../store/userProfile/action";


// Icons
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";


import { LogOut, Wallet } from 'lucide-react';
import { Home, Person2 } from "@mui/icons-material";

const ProfileNavbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.up("sm"));

  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.UserProfile?.allData);
  const { setAuthUser, setIsLoggedIn, isLoggedIn } = useAuth();

  let menuItems = [
    { title: 'Home', path: '/', icon: Home },
    { title: 'Products', path: '/card-list', icon: CardGiftcardIcon },
  ];

  if (isLoggedIn) {
    menuItems = [
      ...menuItems,
      { title: 'My Profile', path: '/profile/user-profile', icon: Person2 },
      { title: 'My Orders', path: '/profile/order', icon: ShoppingBagIcon },
      { title: 'My Statement', path: '/profile/statement', icon: ReceiptIcon },
    ]
  }

  useEffect(() => {
    if (!userProfile?.id && isLoggedIn) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, isLoggedIn, userProfile]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleUserLogout = (e) => {
    e.preventDefault();
    userLogout();
    setAuthUser(null);
    setIsLoggedIn(false);
    navigate("/", { replace: true });
    setOpenDrawer(false);
    handleCloseUserMenu();
  };


  const MobileDrawer = () => (
    <Drawer
      anchor="left"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      PaperProps={{
        sx: {
          width: { xs: 280, sm: 320 },
          backgroundColor: '#f8f9fa',
          borderRadius: '0 16px 16px 0',
          boxShadow: '4px 0 30px rgba(0,0,0,0.06)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }
      }}
      ModalProps={{
        sx: {
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 40, 101, 0.3)',
            backdropFilter: 'blur(4px)',
          }
        }
      }}
    >
      {/* Header Section - Soft Blue & Gold */}
      <Box
        sx={{
          p: 3,
          pb: 2.5,
          // background: `linear-gradient(135deg, ${alpha('#173563', 0.95)} 0%, ${alpha('#1f1302', 0.9)} 100%)`,
          background: 'linear-gradient(135deg, rgba(23, 53, 99, 0.95) 0%, rgb(74 47 9 / 90%) 100%)',
          color: 'white',
          borderBottom: `3px solid #e9b367`,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '-50%',
            right: '-30%',
            width: '200px',
            height: '200px',
            background: `radial-gradient(circle, ${alpha('#e9b367', 0.1)} 0%, transparent 70%)`,
            borderRadius: '50%',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '-40%',
            left: '-20%',
            width: '150px',
            height: '150px',
            background: `radial-gradient(circle, ${alpha('#e9b367', 0.08)} 0%, transparent 70%)`,
            borderRadius: '50%',
          }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', mb: 1, zIndex: 9 }}>
          {/* <IconButton
            onClick={() => setOpenDrawer(false)}
            sx={{
              border: 2,
              borderRadius: 3,
              p: 0.8,
              color: alpha('#ffffff', 1),
              backgroundColor: alpha('#e9b367', 0.1),
              position: 'absolute',
              top: -8,
              right: 0,
              zIndex: 9,
              '&:hover': {
                backgroundColor: alpha('#e9b367', 1),
              }
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton> */}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, position: 'relative', zIndex: 0 }}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  bgcolor: '#4caf50',
                  borderRadius: '50%',
                  border: '1.5px solid #708fbfff',
                  boxShadow: '0 0 8px rgba(76, 175, 80, 0.4)',
                }}
              />
            }
          >
            <Avatar
              alt="Profile"
              sx={{
                width: 45,
                height: 45,
                border: '1px solid #e9b367',
                boxShadow: '0 4px 16px rgba(233, 179, 103, 0.3)',
                bgcolor:"primary.main",
                fontFamily:"Be Vietnam Pro"
              }}
            >
              {userProfile?.firstName
                ?.split(" ")
                ?.slice(0, 2)
                ?.map(word => word.charAt(0))
                ?.join("")
                ?.toUpperCase() || "G"}
            </Avatar>
          </Badge>

          <Box>
            <Typography variant="h6"
              sx={{
                fontFamily: 'Onest, Be Vietnam Pro',
                fontWeight: 600,
                fontSize: '1.5rem',
                color: '#ffffff',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}>
              {userProfile?.firstName || userProfile?.name || "Guest User"}
            </Typography>
            <Typography variant="body2"
              sx={{
                fontFamily: 'Onest, Be Vietnam Pro',
                opacity: 0.9,
                fontSize: '0.9rem',
                color: alpha('#fff', 0.9),
              }}>
              {userProfile?.email || "user@example.com"}
            </Typography>
          </Box>
        </Box>

        {/* Balance Section - Soft Gold Accent */}
        {isLoggedIn && (
          <Box
            sx={{
              mt: 2.5,
              p: 1.5,
              background: `linear-gradient(135deg, ${alpha('#e9b367', 0.15)} 0%, ${alpha('#e9b367', 0.05)} 100%)`,
              borderRadius: 2,
              border: `1px solid ${alpha('#e9b367', 0.2)}`,
              position: 'relative',
              zIndex: 1,
              backdropFilter: 'blur(10px)',
            }}
          >
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 0.5,
            }}>
              <Typography variant="caption" sx={{
                opacity: 0.8,
                display: 'block',
                color: alpha('#fff', 0.8),
                fontSize: '0.7rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                fontFamily: 'Onest, Be Vietnam Pro',
              }}>
                Wallet Balance
              </Typography>
            </Box>

            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}>
              <Wallet
                size={20}
                color="#e9b367"
                strokeWidth={2}
                style={{ opacity: 0.7 }}
              />
              <Typography variant="h5" sx={{
                fontWeight: 700,
                color: '#e9b367',
                textShadow: '0 2px 8px rgba(233, 179, 103, 0.2)',
                fontFamily: 'Onest, Be Vietnam Pro, sans-serif',
                letterSpacing: '0.5px',
              }}>
                AED {userProfile?.walletDatum?.amount || "0"}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>

      {/* Menu List - Scrollable with hidden scrollbar */}
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          px: 1.5,
          py: 1,
          '&::-webkit-scrollbar': {
            width: '0px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'transparent',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        <List sx={{ p: 0 }}>
          {menuItems.map((item, idx) => {
            const Icon = item.icon;
            const isActive = window.location.pathname === item.path;

            return (
              <ListItemButton
                key={idx}
                onClick={() => {
                  navigate(item.path);
                  setOpenDrawer(false);
                }}
                sx={{
                  borderRadius: 2,
                  mb: 0.5,
                  py: 1.2,
                  px: 2,
                  backgroundColor: isActive ? alpha('#002865', 0.06) : 'transparent',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: alpha('#002865', 0.04),
                    transform: 'translateX(4px)',
                  },
                  '& .MuiListItemIcon-root': {
                    minWidth: 40,
                  },
                }}
              >
                <ListItemIcon>
                  <Icon
                    sx={{
                      color: isActive ? '#002865' : alpha("#6b7a8f", 0.8),
                      fontSize: 26,
                      transition: 'color 0.3s',
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{
                    fontFamily: 'Onest, Be Vietnam Pro',
                    fontSize: '1.2rem',
                    fontWeight: isActive ? 700 : 500,
                    color: isActive ? '#002865' : alpha("#6b7a8f", 0.8),
                    transition: 'color 0.3s',
                  }}
                />
                {isActive && (
                  <Box
                    sx={{
                      width: 3,
                      height: 24,
                      bgcolor: alpha("#002865", 1),
                      borderRadius: 2,
                      boxShadow: '0 0 12px rgba(233, 179, 103, 0.3)',
                    }}
                  />
                )}
              </ListItemButton>
            );
          })}
        </List>
      </Box>

      {/* Footer - Soft Gold Accent */}
      {isLoggedIn && (
        <Box
          sx={{
            p: 2,
            textAlign: 'center',
            borderTop: `1px solid ${alpha('#002865', 0.06)}`,
            backgroundColor: alpha('#f8f9fa', 0.9),
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: alpha('#f44336', 0.1),
            }
          }}
          onClick={handleUserLogout}
        >
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            pl: 3,
            gap: 1,
            fontFamily: 'Onest, Be Vietnam Pro',
          }}>
            <LogOut
              size={18}
              color="#f44336"
              strokeWidth={2}
            />
            <Typography
              sx={{
                transition: 'all 0.2s ease',
                fontFamily: 'Onest, Be Vietnam Pro',
                fontSize: '1.2rem',
                fontWeight: 500,
                color: alpha("#f44336", 0.8),
                '&:hover': {
                  color: alpha("#f44336", 1),
                  transform: 'translateX(2px)',
                }
              }}
            >
              Logout
            </Typography>
          </Box>
        </Box>
      )}
    </Drawer>
  );

  // Mobile/Tablet view - Hamburger menu
  if (isMobile || isTablet) {
    return (
      <>
        <IconButton
          onClick={() => setOpenDrawer(true)}
          sx={{
            color: alpha(theme.palette.secondary.main, 1),
            border: 1.5,
            borderRadius: 3,
            transition: 'all 0.3s',
            borderColor: alpha(theme.palette.secondary.main, 1),

            '&:hover': {
              color: alpha(theme.palette.white.main, 1),
              borderColor: alpha(theme.palette.secondary.main, 1),
              backgroundColor: alpha(theme.palette.secondary.main, 0.5),
              background: 'linear-gradient(135deg, rgba(23, 53, 99, 0.95) 0%, rgb(74 47 9 / 90%) 100%)',
              boxShadow: 4
            },
            '&:active': {
              transform: 'scale(0.9)',
            }
          }}
        >
          <MenuIcon />
        </IconButton>

        <MobileDrawer />
      </>
    );
  }
};

export default ProfileNavbar;
